import Joi from 'joi';

const ThreeDsInputData = Joi.object().keys({
  acquirerId: Joi.string().allow(''),
  acquirerMid: Joi.string().allow(''),
  requestorId: Joi.string().allow('')
});

export default ThreeDsInputData;
